import * as Core from '@skylab-shared/core';
import { Company, InventoryDocumentKind, InventoryKindModel } from '@skylab-shared/dataModel';
import { InventoryKindCustomTransactionLocationEmptyError } from '../../../../angular-business/src/lib/inventory/violations/inventory-kind-custom-transaction-location-empty-error';
import { ContextKeys } from '../common/context-keys';
import { propertyChangedJoinPointFilter } from '../common/property-changed/property-changed-filter';


@Core.BO({ modelType: InventoryKindModel })
export class InventoryKindBO extends Core.BusinessObjectBase<InventoryKindModel> {
    public constructor(
        weaver: Core.Weaver,
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        await Promise.resolve([
            this.localContext.preload(ContextKeys.company),
        ]);
        this.setTransactionLocation();
        this.registerCoreFeatures();
    }

    public registerCoreFeatures(): void {
        this.setReadonlyProperties();
        this.setLocationAfterUseCustomTransactionChange();
        this.setLocationAfterCustomTransactionChange();
        this.requireCustomTransactionLocation();
    }

    private setReadonlyProperties(): void {
        this.readonly.setAsReadonly<InventoryKindModel>([InventoryKindModel, 'name']);

        this.readonly.addRule(
            [[InventoryKindModel, 'useCustomTransactionLocation']],
            [[InventoryKindModel, 'customTransactionLocation']],
            ctx => !ctx.source.useCustomTransactionLocation
        );
    }

    private setLocationAfterUseCustomTransactionChange(): void {
        this.registerListening(this.weaver.register(Core.PropertyChangedJoinPoint, propertyChangedJoinPointFilter(this)(InventoryKindModel, ['useCustomTransactionLocation'])(
            _ => this.setTransactionLocation()
        )));
    }

    private setLocationAfterCustomTransactionChange(): void {
        this.registerListening(this.weaver.register(Core.PropertyChangedJoinPoint, propertyChangedJoinPointFilter(this)(InventoryKindModel, ['customTransactionLocation'])(
            _ => this.setTransactionLocation()
        )));
    }

    private setTransactionLocation(): void {
        if (!this.model.useCustomTransactionLocation) {
            const company: Company = this.localContext.getPreloaded(ContextKeys.company);
            this.model.customTransactionLocation = company.city;
        }
    }

    private requireCustomTransactionLocation(): void {
        this.validation.addRule(
            [[InventoryKindModel, 'useCustomTransactionLocation'], [InventoryKindModel, 'customTransactionLocation']],
            [[InventoryKindModel, 'customTransactionLocation']],
            ctx => {
                if (!this.isGoodsIssueType) return true;

                if (ctx.source.useCustomTransactionLocation) {
                    return ctx.source.customTransactionLocation.length > 0;
                }
                return true;
            },
            InventoryKindCustomTransactionLocationEmptyError
        );
    }

    public get isGoodsIssueType(): boolean {
        return [InventoryDocumentKind.GoodsIssue, InventoryDocumentKind.GoodsIssueAdjustment, InventoryDocumentKind.InternalGoodsIssue].includes(this.model.name);
    }
}
